import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Navigation from "@/components/Navigation";
import { SEOHead } from "@/components/SEOHead";

const modules = [
  { number: 1, title: "Revenue Kickoff & Strategy Orientation" },
  { number: 2, title: "Profit Product Launch Blueprint" },
  { number: 3, title: "Millionaire Mindset Mastery" },
  { number: 4, title: "Store Success System" },
  { number: 5, title: "Digital Asset Powerhouse" },
  { number: 6, title: "Automated Revenue Engine" },
  { number: 7, title: "Funding Unlock Formula" },
  { number: 8, title: "Business Credit Mastery" },
  { number: 9, title: "Customer Loyalty Blueprint" },
  { number: 10, title: "Etsy Growth Accelerator" },
  { number: 11, title: "AI Revenue Lab" },
  { number: 12, title: "Secret Income Streams" },
  { number: 13, title: "AI Content Mastery" },
  { number: 14, title: "Government Contract Goldmine" },
  { number: 15, title: "Automated Marketing Machine" },
  { number: 16, title: "Digital Wealth Investing" },
  { number: 17, title: "Ultimate Wealth Blueprint" },
  { number: 18, title: "Affiliate Income System" },
  { number: 19, title: "Amazon Sales Accelerator" },
  { number: 20, title: "PLR Profit Shop" },
  { number: 21, title: "Print-on-Demand Profit Plan" },
  { number: 22, title: "Google Ads Profit System" },
  { number: 23, title: "Meta Ads Profit Engine" },
  { number: 24, title: "Customer Loyalty Blueprint" },
  { number: 25, title: "Automated Marketing Machine" },
  { number: 26, title: "Email Marketing Empire" },
  { number: 27, title: "Podcast Revenue Suite" }
];

const FullCurriculum = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEOHead
        title="Full Curriculum - 27 Modules - LaunchToRevenue"
        description="Explore our complete 27-module curriculum covering everything from revenue kickoff to automated marketing, AI content mastery, and multiple income streams."
        keywords="business curriculum, entrepreneurship modules, digital marketing course, revenue generation training, online business education"
        url="https://launchpad-to-riches.lovable.app/full-curriculum"
        type="course"
      />
      <Navigation />
      <main className="min-h-screen pt-16">
        <section className="py-24 px-4">
          <div className="container mx-auto max-w-7xl">
            <Button
              variant="ghost"
              onClick={() => navigate("/")}
              className="mb-8"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>

            <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
              <h1 className="text-4xl md:text-6xl font-bold tracking-tight">
                Complete <span className="text-primary">Curriculum</span>
              </h1>
              <p className="text-xl text-muted-foreground">
                All 27 modules designed to take you from zero to multiple revenue streams
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {modules.map((module, index) => (
                <Card 
                  key={index} 
                  className="border-2 hover:border-primary/30 transition-all hover:shadow-lg hover:shadow-primary/20"
                >
                  <CardHeader className="pb-4">
                    <div className="flex items-start gap-3">
                      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center text-white font-bold text-sm">
                        {module.number}
                      </div>
                      <CardTitle className="text-base leading-tight pt-1">{module.title}</CardTitle>
                    </div>
                  </CardHeader>
                </Card>
              ))}
            </div>

            <div className="mt-16 text-center">
              <div className="inline-block p-8 bg-gradient-to-r from-primary/20 to-accent/20 rounded-2xl border-2 border-primary/40">
                <h3 className="text-2xl font-bold mb-4">Ready to Start Your Journey?</h3>
                <p className="text-muted-foreground mb-6 max-w-xl">
                  Get instant access to all 27 modules, lifetime community support, and weekly coaching calls
                </p>
                <Button size="lg" onClick={() => navigate("/auth")}>
                  Enroll Now
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default FullCurriculum;
